import {
  BroadcastInitialValue,
  useActionTab,
  useCreateLocationBroadcastedValue,
} from '@kinetic-ui/broadcast';
import { LocationTypes } from '@kinetic-ui/shared';
import { CREATE_LOCATION_ACTION_ROUTE } from '~/router/constants';
import { getActionRoute } from '~/router/getActionRoute';

type UseCreateLocationActionOptions = BroadcastInitialValue<
  typeof useCreateLocationBroadcastedValue
> & {
  defaultLocationType?: LocationTypes;
};
export const useCreateLocationAction = ({
  initialValue,
  defaultLocationType,
}: UseCreateLocationActionOptions) => {
  const { openActionTab, actionTabRef } = useActionTab({
    tabRoute: getActionRoute(`${CREATE_LOCATION_ACTION_ROUTE}/${defaultLocationType ?? ''}`),
    target: 'location',
  });
  const value = useCreateLocationBroadcastedValue({ initialValue });
  return {
    openActionTab,
    actionTabRef,
    value,
  };
};
